import React from "react";
import PropTypes from "prop-types";
import { SketchPicker } from "react-color";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

import useDeviceType from "../../../../hooks/common/useDeviceType";

const pickerWrapperSx = {
  "& > .sketch-picker": {
    boxShadow: "none!important"
  }
};

function ColorPickDialog({ color, closePopup, isOpen, handleChange, disabledTransparent }) {
  const { isMobile } = useDeviceType();

  return (
    <Dialog
      open={isOpen}
      onClose={closePopup}
      aria-labelledby="color-pick-dialog-title"
      aria-describedby="color-pick-dialog-description"
      maxWidth="sm">
      <DialogTitle id="color-pick-dialog-title">Pick a color</DialogTitle>
      <DialogContent sx={pickerWrapperSx}>
        <SketchPicker
          width={isMobile ? 290 : 320}
          color={color || false}
          value={color}
          presetColors={[]}
          disableAlpha
          onChange={handleChange}
        />
        <Button
          disabled={disabledTransparent}
          sx={{ mt: "10px" }}
          onClick={() => !disabledTransparent && handleChange({ hex: "transparent" })}>
          Transparent
        </Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={closePopup} type="button">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ColorPickDialog;

ColorPickDialog.propTypes = {
  color: PropTypes.string,
  closePopup: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  disabledTransparent: PropTypes.bool
};

ColorPickDialog.defaultProps = {
  isOpen: false,
  color: ""
};
